import ENV from 'sh-www/config/environment';

/**
 * @type {Object} The object containing all the support links.
 */
export const SUPPORT = {
  SELECT_FOR_BUYERS: `https://${ENV.supportDomain}/en/articles/8482494-what-is-glimmer-select`,
  SELECT_FOR_SELLERS: `https://${ENV.supportDomain}/en/articles/8392482-glimmer-select-faq`,
  SELLER_FEES: `https://${ENV.supportDomain}/en/articles/8392475-creator-service-fee`,
};
